import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a5210b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "顶 部", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "足 迹", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "撷 英", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "省 思", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求 索", -1))

import { ref, onMounted, onUnmounted } from "vue";
import {
  ChatDotRound,
  Guide,
  Ship,
  Sunrise,
  Trophy,
} from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {

const active = ref("top");
const sections = ["writing", "collection", "footprint", "top"];
const goAnchor = (selector: string) => {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
    });
  }
};
const handleSelect = (key: string) => {
  if (key == "research") {
    window.open("#/research");
  } else {
    goAnchor(`#${key}`);
  }
};
const listenScroll = () => {
  for (const section of sections) {
    const element = document.querySelector(`#${section}`);
    if (element && element.getBoundingClientRect().top <= 0) {
      active.value = section;
      break;
    }
  }
};

onMounted(() => {
  document.addEventListener("scroll", listenScroll);
});

onUnmounted(() => {
  document.removeEventListener("scroll", listenScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": active.value,
    onSelect: handleSelect,
    class: "side-menu"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, { index: "top" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Sunrise))
            ]),
            _: 1
          }),
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "footprint" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Guide))
            ]),
            _: 1
          }),
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "collection" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Trophy))
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "writing" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(ChatDotRound))
            ]),
            _: 1
          }),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "research" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Ship))
            ]),
            _: 1
          }),
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})